export const facilityHeader = [
  {
    id: 'serialNumber',
    label: '관리번호',
  },
  {
    id: 'title',
    label: '시설명',
  },
  {
    id: 'categoryId',
    label: '구분',
  },

  {
    id: 'subCategory',
    label: '기구명',
  },
  {
    id: 'addressName',
    label: '주소',
  },
  {
    id: 'addressNote',
    label: '위치참고',
  },

  {
    id: 'dateOfInstall',
    label: '설치일',
  },

  {
    id: 'ownershipType',
    label: '설치유형',
  },
  {
    id: 'usedAs',
    label: '유형상세',
  },
  {
    id: 'occupyingSpace',
    label: '설치면적',
  },
  {
    id: 'buget',
    label: '사업비(국비/시비/구비)',
  },
  {
    id: 'installedDepartment',
    label: '설치부서/담당부서',
  },
  {
    id: 'maintenanceDepartment',
    label: '관리부서',
  },
  {
    id: 'manageDepartment',
    label: '총괄부서',
  },
  {
    id: 'contactNumber',
    label: '연락처',
  },
  {
    id: 'consignedOrg',
    label: '위탁기관',
  },
  {
    id: 'during',
    label: '위탁기간',
  },
  {
    id: 'notes',
    label: '비고',
  },
  {
    id: 'inspectionScore',
    label: '상태등급',
  },
  {
    id: 'inspectionDate',
    label: '점검일자',
  },
  {
    id: 'inspectionResult',
    label: '상태비고',
  },
];

export const selectedHeader = [
  {
    id: 'serialNumber',
    label: '관리번호',
  },
  {
    id: 'category',
    label: '구분',
  },
  {
    id: 'title',
    label: '시설명',
  },
  {
    id: 'subCategory',
    label: '기구명',
  },
  {
    id: 'addressName',
    label: '주소',
  },
  {
    id: 'addressNote',
    label: '위치참고',
  },
  {
    id: 'inspectionScore',
    label: '상태등급',
  },

  {
    id: 'dateOfInstall',
    label: '설치일',
  },

  {
    id: 'ownershipType',
    label: '설치유형',
  },
  {
    id: 'usedAs',
    label: '유형상세',
  },
  {
    id: 'occupyingSpace',
    label: '설치면적',
  },
  {
    id: 'installCostNation',
    label: '사업비(국비)',
  },
  {
    id: 'installCostCity',
    label: '사업비(시비)',
  },
  {
    id: 'installCostDistrict',
    label: '사업비(구비)',
  },
  {
    id: 'installedDepartment',
    label: '설치부서/담당부서',
  },
  {
    id: 'maintenanceDepartment',
    label: '관리부서',
  },
  {
    id: 'managingDepartment',
    label: '총괄부서',
  },
  {
    id: 'contactNumber',
    label: '연락처',
  },
  {
    id: 'consignedOrgTitle',
    label: '위탁기관',
  },
  {
    id: 'consignedStartDate',
    label: '위탁기관(시작일)',
  },
  {
    id: 'consignedEndDate',
    label: '위탁기간(마감일)',
  },
  {
    id: 'notes',
    label: '비고',
  },
];
